import { Sparkles, Heart, Zap, Hand, Smile, Droplets, Wind, Scissors, Footprints, Snowflake, Flame } from 'lucide-react';

export interface Prestation {
  name: string;
  duration: string;
  price: string;
  description?: string;
  isSupplementHeader?: boolean;
  premium?: boolean;
}

export interface Service {
  slug: string;
  icon: any;
  title: string;
  shortDesc: string;
  heroSubtitle: string;
  planityUrl: string;
  content: { heading: string; text: string }[];
  prestations: Prestation[];
  supplements?: string[];
  premium?: boolean;
}

export const PLANITY_URL = 'https://www.planity.com/body-by-cc-93270-sevran';

export const services: Service[] = [
  {
    slug: 'hifu',
    icon: Zap,
    title: 'HIFU — Lifting sans chirurgie',
    shortDesc: 'Alternative au lifting par ultrasons focalisés. Raffermissement visage & corps sans chirurgie, résultats durables.',
    heroSubtitle: 'Le HIFU : une alternative non invasive au lifting chirurgical. Raffermissement en profondeur, résultats visibles et naturels.',
    planityUrl: PLANITY_URL,
    premium: true,
    content: [
      { heading: 'Retrouvez confiance en votre reflet', text: 'Le HIFU (High Intensity Focused Ultrasound) est une technologie révolutionnaire qui retend la peau et redéfinit l\'ovale du visage sans bistouri. Les résultats sont progressifs et naturels — pour vous sentir bien dans votre peau, tout simplement.' },
      { heading: 'Un protocole complet et rassurant', text: 'Chaque zone est traitée avec précision par Carine, infirmière diplômée. Le prix inclut 1 séance + 2 retouches pour un résultat optimal et durable. Nous traitons le visage et le corps.' },
      { heading: 'Sécurité et confort', text: 'Nos appareils de dernière génération garantissent un traitement sûr, précis et confortable. Les séances sont rapides et ne nécessitent aucune éviction sociale.' },
    ],
    prestations: [
      { name: 'HIFU cuisses', duration: '1h', price: '550 €', premium: true },
      { name: 'HIFU ventre complet', duration: '50 min', price: '380 €', premium: true },
      { name: 'HIFU fesses', duration: '40 min', price: '350 €', premium: true },
      { name: 'HIFU intérieur cuisses', duration: '40 min', price: '350 €', premium: true },
      { name: 'HIFU poignées d\'amour', duration: '40 min', price: '300 €', premium: true },
      { name: 'HIFU front + pattes d\'oies', duration: '40 min', price: '270 €', premium: true },
      { name: 'HIFU biceps', duration: '30 min', price: '250 €' },
      { name: 'HIFU front', duration: '20 min', price: '170 €' },
      { name: 'HIFU pattes d\'oies', duration: '20 min', price: '170 €' },
      { name: 'HIFU ovale du visage', duration: '30 min', price: '170 €' },
      { name: 'HIFU joues', duration: '25 min', price: '150 €' },
      { name: 'HIFU genoux', duration: '30 min', price: '150 €' },
      { name: 'HIFU sillon naso-génien', duration: '20 min', price: '140 €' },
      { name: 'HIFU contour de la bouche', duration: '15 min', price: '100 €' },
    ],
  },
  {
    slug: 'cryotherapie',
    icon: Snowflake,
    title: 'E-SLIM Cryo 360°',
    shortDesc: 'Cryothérapie minceur dernière génération. Perdez jusqu\'à 4 cm dès la 1ère séance, sans effort.',
    heroSubtitle: 'La solution minceur par le froid : E-SLIM Cryo 360°, la machine dernier cri pour remodeler votre silhouette en douceur.',
    planityUrl: PLANITY_URL,
    premium: true,
    content: [
      { heading: 'La solution pour se sentir bien dans son corps', text: 'L\'E-SLIM Cryo 360° est la technologie minceur la plus avancée du marché. En combinant le froid ciblé et la stimulation métabolique, elle permet de perdre jusqu\'à 4 cm dès la première séance — sans douleur, sans chirurgie, sans éviction sociale.' },
      { heading: 'Une approche bien-être, pas un régime', text: 'Chez Body by CC, la cryothérapie s\'inscrit dans une démarche de bien-être global. Il ne s\'agit pas de transformer votre corps, mais de vous accompagner vers une silhouette dans laquelle vous vous sentez bien et en confiance.' },
      { heading: 'Technologie dernier cri', text: 'L\'E-SLIM Cryo 360° est un équipement professionnel de pointe, manipulé par Carine Tchuente, infirmière diplômée. Chaque séance est personnalisée et encadrée avec rigueur et bienveillance.' },
    ],
    prestations: [
      { name: 'Cryo ventre complet', duration: '45 min', price: 'Sur devis', premium: true, description: 'Traitement ciblé du ventre par cryothérapie pour un remodelage visible.' },
      { name: 'Cryo cuisses', duration: '45 min', price: 'Sur devis', premium: true, description: 'Réduit les amas graisseux tenaces au niveau des cuisses.' },
      { name: 'Cryo poignées d\'amour', duration: '30 min', price: 'Sur devis', premium: true, description: 'Cible les bourrelets latéraux pour une silhouette affinée.' },
      { name: 'Cryo fesses / culotte de cheval', duration: '45 min', price: 'Sur devis', premium: true, description: 'Traitement de la culotte de cheval et remodelage fessier.' },
    ],
  },
  {
    slug: 'soins-visage',
    icon: Sparkles,
    title: 'Soins du Visage',
    shortDesc: 'Hydratation, anti-âge, éclat & purification. Des soins sur-mesure pour révéler votre beauté naturelle.',
    heroSubtitle: 'Des soins visage personnalisés pour chaque type de peau, alliant technologie de pointe et accompagnement bienveillant.',
    planityUrl: PLANITY_URL,
    content: [
      { heading: 'Prendre soin de soi, c\'est essentiel', text: 'Chez Body by CC, chaque soin visage commence par un diagnostic personnalisé. Que votre peau soit sèche, grasse, mixte ou sensible, nous sélectionnons les protocoles les plus adaptés pour révéler votre éclat naturel et vous aider à vous sentir bien.' },
      { heading: 'Technologies de pointe', text: 'Nous utilisons des technologies avancées — Skincleantech, photothérapie LED, peeling, électro-mésothérapie — pour des résultats visibles dès la première séance. Nos soins sont réalisés en toute douceur et sans douleur.' },
      { heading: 'Résultats durables', text: 'Grâce à des actifs de haute qualité et des protocoles éprouvés, nos soins visage offrent des résultats durables. Anti-âge, éclat, hydratation profonde : votre peau retrouve jeunesse et luminosité.' },
    ],
    prestations: [
      { name: 'Électro-Mésothérapie', duration: '1h30', price: '150 €', premium: true, description: 'Soin anti-âge avancé par courants de basse fréquence. Stimule la production de collagène en profondeur.' },
      { name: 'Hightechskin — Anti-âge & relâchement', duration: '1h20', price: '120 €', premium: true, description: 'Stimule le collagène, lisse les rides et retend les tissus relâchés.' },
      { name: 'Ultraliftskin — Anti-âge repulpant', duration: '1h15', price: '110 €', premium: true, description: 'Lisse les rides et raffermit les traits.' },
      { name: 'Hydrafacial', duration: '40 min', price: '110 €', premium: true },
      { name: 'Peeldermaskin Light', duration: '50 min', price: '110 €', description: 'Exfolie la peau et élimine les cellules mortes.' },
      { name: 'Shineskin — Peaux ternes & fatiguées', duration: '50 min', price: '95 €', description: 'Illumine et revitalise le teint.' },
      { name: 'Hydracleanskin — Peaux sèches à déshydratées', duration: '50 min', price: '80 €', description: 'Hydratation intense, restaure confort et éclat.' },
      { name: 'Softskin — Peaux sensibles', duration: '50 min', price: '80 €', description: 'Apaise les irritations et renforce la barrière cutanée.' },
      { name: 'Aquapurskin — Peaux mixtes à grasses', duration: '45 min', price: '55 €', description: 'Élimine l\'excès de sébum, désincruste les pores et affine le grain de peau.' },
      { name: 'Eyedermaskin — Contour des yeux', duration: '40 min', price: '50 €', description: 'Réduit cernes, poches et ridules pour un regard reposé et lumineux.' },
      { name: 'Skincleantech', duration: '30 min', price: '35 €', description: 'Nettoyage profond et purification de la peau.' },
      { name: 'Acnéskin — Soin purifiant', duration: '25 min', price: '35 €', description: 'Nettoie en profondeur, purifie et régule l\'excès de sébum pour une peau plus saine.' },
      { name: 'Photothérapie LED', duration: '25 min', price: '20 €', description: 'Stimule la régénération cellulaire et réduit les imperfections.' },
    ],
  },
  {
    slug: 'soins-corps',
    icon: Heart,
    title: 'Soins du Corps',
    shortDesc: 'Pressothérapie, lipolaser, sauna infrarouge & électrolyse pour retrouver bien-être et légèreté.',
    heroSubtitle: 'Des technologies avancées pour drainer, sculpter et revitaliser votre corps — dans une démarche de bien-être global.',
    planityUrl: PLANITY_URL,
    content: [
      { heading: 'Retrouvez légèreté et bien-être', text: 'Nos soins corps combinent les meilleures technologies — lipolaser, pressothérapie, sauna infrarouge — pour vous accompagner vers un mieux-être physique. Parce que se sentir bien dans son corps, c\'est se sentir bien dans sa vie.' },
      { heading: 'Pressothérapie multi-usages', text: 'La pressothérapie est un soin complet : minceur, diminution de la cellulite, rétention d\'eau, problèmes circulatoires, récupération sportive, post-partum. Un véritable soin santé et bien-être.' },
      { heading: 'Sauna infrarouge — Nouveauté', text: 'Notre sauna infrarouge 3-4 places offre une détente profonde, favorise l\'élimination des toxines et améliore la circulation. Offre découverte : 20 min pour 20 €.' },
    ],
    prestations: [
      { name: 'Sauna infrarouge — Offre Découverte', duration: '20 min', price: '20 €', description: 'Détente profonde, élimination des toxines, amélioration de la circulation. Sauna infrarouge 3-4 places.' },
      { name: 'Pressothérapie — Retour veineux', duration: '30 min', price: '35 €', description: 'Stimule la circulation sanguine et soulage les jambes lourdes.' },
      { name: 'Pressothérapie — Cellulite', duration: '30 min', price: '35 €', description: 'Réduit l\'aspect peau d\'orange et lisse les tissus.' },
      { name: 'Pressothérapie — Modelage', duration: '30 min', price: '35 €', description: 'Affine la silhouette et favorise le drainage.' },
      { name: 'Pressothérapie — Détente & relaxation', duration: '30 min', price: '35 €', description: 'Moment de lâcher-prise et de bien-être profond.' },
      { name: 'Pressothérapie — Drainage lymphatique', duration: '30 min', price: '35 €', description: 'Élimine les toxines et réduit la rétention d\'eau.' },
      { name: 'Pressothérapie — Récupération sportive', duration: '30 min', price: '35 €', description: 'Récupération musculaire accélérée après l\'effort.' },
      { name: 'Lipolaser — Cuisses + genoux', duration: '30 min', price: '30 €', description: 'Cible les amas graisseux au niveau des cuisses et genoux.' },
      { name: 'Lipolaser — Fesses + culotte de cheval', duration: '30 min', price: '30 €', description: 'Affine la zone fessière et réduit la culotte de cheval.' },
      { name: 'Lipolaser — Ventre + poignées d\'amour', duration: '30 min', price: '30 €', description: 'Cible les bourrelets abdominaux et latéraux.' },
      { name: 'Électrolyse', duration: '30 min', price: 'Sur devis', description: 'Épilation définitive poil par poil pour un résultat impeccable et durable.' },
    ],
  },
  {
    slug: 'epilation',
    icon: Scissors,
    title: 'Épilation',
    shortDesc: 'Épilation définitive & cire. Solutions adaptées à tous les phototypes, y compris peaux noires et métissées.',
    heroSubtitle: 'Des solutions d\'épilation sûres et adaptées à chaque type de peau, réalisées par une infirmière diplômée.',
    planityUrl: PLANITY_URL,
    content: [
      { heading: 'Épilation définitive — Toutes peaux', text: 'Body by CC est l\'un des rares instituts à proposer l\'épilation définitive adaptée aux peaux noires et métissées. Des protocoles sûrs calibrés par une infirmière diplômée.' },
      { heading: 'Épilation à la cire', text: 'Profitez de nos formules épilation cire pour un résultat complet à prix avantageux. Du maillot aux jambes entières, en passant par les bras et les aisselles.' },
      { heading: 'Confort et sécurité', text: 'Chaque épilation est réalisée avec des produits de qualité professionnelle et un accompagnement bienveillant pour un confort optimal.' },
    ],
    prestations: [
      { name: 'Grande zone Homme', duration: '1h', price: '170 €', premium: true, description: 'Épilation définitive grande zone pour homme.' },
      { name: 'Grande zone Femme', duration: '45 min', price: '150 €', premium: true, description: 'Épilation définitive grande zone pour femme.' },
      { name: 'Moyenne zone Homme', duration: '35 min', price: '120 €', description: 'Épilation définitive moyenne zone pour homme.' },
      { name: 'Moyenne zone Femme', duration: '25 min', price: '100 €', description: 'Épilation définitive moyenne zone pour femme.' },
      { name: 'Petite zone Homme', duration: '25 min', price: '75 €', description: 'Épilation définitive petite zone pour homme.' },
      { name: 'Petite zone Femme', duration: '20 min', price: '70 €', description: 'Épilation définitive petite zone pour femme.' },
      { name: 'Mini zone Homme', duration: '10 min', price: '45 €', description: 'Épilation définitive mini zone pour homme.' },
      { name: 'Mini zone Femme', duration: '10 min', price: '40 €', description: 'Épilation définitive mini zone pour femme.' },
      { name: 'Maillot intégral (cire)', duration: '25 min', price: '30 €' },
      { name: 'Jambes entières (cire)', duration: '25 min', price: '25 €' },
      { name: 'Bras entiers (cire)', duration: '20 min', price: '20 €' },
      { name: 'Maillot brésilien (cire)', duration: '20 min', price: '20 €' },
      { name: 'Maillot classique (cire)', duration: '15 min', price: '15 €' },
      { name: '½ jambes (cire)', duration: '15 min', price: '15 €' },
      { name: '½ bras (cire)', duration: '15 min', price: '12 €' },
      { name: 'Aisselles (cire)', duration: '15 min', price: '10 €' },
      { name: 'Sourcils (cire)', duration: '10 min', price: '8 €' },
      { name: 'SIF (cire)', duration: '5 min', price: '7 €' },
      { name: 'Lèvres ou menton (cire)', duration: '5 min', price: '5 €' },
      { name: 'Lèvres/menton/sourcils (cire)', duration: '15 min', price: '15 €' },
    ],
  },
  {
    slug: 'blanchiment-dentaire',
    icon: Smile,
    title: 'Blanchiment Dentaire',
    shortDesc: 'Gagnez jusqu\'à 4 teintes en une seule séance. Rapide, sûr et totalement indolore.',
    heroSubtitle: 'Un sourire éclatant en une seule séance grâce à notre blanchiment dentaire professionnel.',
    planityUrl: PLANITY_URL,
    content: [
      { heading: 'Souriez en toute confiance', text: 'En une seule séance, gagnez jusqu\'à 4 teintes plus claires. La méthode est rapide, sûre et totalement indolore. Votre sourire retrouve tout son éclat — et avec lui, votre confiance.' },
      { heading: 'Méthode professionnelle', text: 'Notre protocole de blanchiment utilise des produits professionnels conformes aux normes européennes. Le traitement est sans danger pour l\'émail de vos dents.' },
    ],
    prestations: [
      { name: 'Blanchiment 60 minutes', duration: '1h', price: '90 €', premium: true },
      { name: 'Blanchiment 40 minutes', duration: '40 min', price: '70 €' },
      { name: 'Blanchiment 20 minutes', duration: '20 min', price: '50 €' },
    ],
  },
  {
    slug: 'massages',
    icon: Wind,
    title: 'Massages Bien-être',
    shortDesc: 'Massages manuels aux huiles essentielles pour une détente profonde du corps et de l\'esprit.',
    heroSubtitle: 'Des massages de bien-être réalisés entièrement à la main pour un lâcher-prise total et une reconnexion à soi.',
    planityUrl: PLANITY_URL,
    content: [
      { heading: 'Un moment rien que pour vous', text: 'Nos massages de bien-être aux huiles essentielles sont réalisés entièrement à la main. Un soin enveloppant qui libère les tensions, apaise le stress et vous reconnecte à votre corps.' },
      { heading: 'Plusieurs zones au choix', text: 'Dos, jambes, visage & cuir chevelu, haut du corps ou massage enveloppant de la tête aux pieds : choisissez le soin qui vous correspond.' },
    ],
    prestations: [
      { name: 'Massage complet', duration: '50 min', price: '50 €', premium: true, description: 'Détente profonde, lâcher-prise total et harmonie du corps.' },
      { name: 'Massage haut du corps', duration: '45 min', price: '40 €', description: 'Dos, épaules, bras et nuque pour une relaxation profonde.' },
      { name: 'Massage dos relaxant', duration: '30 min', price: '25 €' },
      { name: 'Massage jambes légères', duration: '30 min', price: '25 €', description: 'Stimule la circulation et procure une sensation de légèreté.' },
      { name: 'Massage visage & cuir chevelu', duration: '30 min', price: '25 €', description: 'Relâche les tensions, apaise l\'esprit et illumine le teint.' },
    ],
  },
  {
    slug: 'manucure',
    icon: Hand,
    title: 'Manucure',
    shortDesc: 'Manucure, vernis semi-permanent, pose gel & capsules pour des mains sublimées.',
    heroSubtitle: 'Manucure soignée avec des finitions impeccables pour sublimer vos mains.',
    planityUrl: PLANITY_URL,
    content: [
      { heading: 'Prenez soin de vos mains', text: 'De la manucure simple au vernis semi-permanent en passant par la pose de gel et capsules, nous prenons soin de vos ongles avec minutie et créativité.' },
      { heading: 'Des produits de qualité', text: 'Nous utilisons exclusivement des produits professionnels haut de gamme pour une tenue longue durée et un résultat impeccable.' },
    ],
    prestations: [
      { name: 'Pose gel / capsules / résine', duration: '1h', price: '50 €' },
      { name: 'Vernis semi-permanent', duration: '30 min', price: '25 €' },
      { name: 'Manucure complète + vernis', duration: '1h', price: '25 €' },
      { name: 'Manucure complète', duration: '30 min', price: '20 €' },
      { name: 'Manucure simple + vernis', duration: '30 min', price: '15 €' },
      { name: 'Manucure simple', duration: '30 min', price: '12 €' },
      { name: 'Vernis simple mains', duration: '30 min', price: '10 €' },
      { name: 'Dépose', duration: '30 min', price: '5 €' },
    ],
    supplements: ['Semi-permanent : 15 €', 'Nail art : 10 €'],
  },
  {
    slug: 'beaute-des-pieds',
    icon: Footprints,
    title: 'Beauté des Pieds',
    shortDesc: 'Pédicure, vernis semi-permanent et soins complets pour des pieds sublimés.',
    heroSubtitle: 'Offrez à vos pieds le soin qu\'ils méritent. Pédicure complète et vernis pour des pieds doux et sublimés.',
    planityUrl: PLANITY_URL,
    content: [
      { heading: 'Beauté des pieds', text: 'Offrez à vos pieds le soin qu\'ils méritent. Pédicure complète, gommage, hydratation et vernis pour des pieds doux et sublimés.' },
      { heading: 'Des produits de qualité', text: 'Nous utilisons exclusivement des produits professionnels haut de gamme pour une tenue longue durée et un résultat impeccable.' },
    ],
    prestations: [
      { name: 'Beauté des pieds complète', duration: '30 min', price: '35 €' },
      { name: 'Vernis semi-permanent pieds', duration: '30 min', price: '30 €' },
      { name: 'Beauté des pieds simple', duration: '30 min', price: '20 €' },
      { name: 'Vernis simple pieds', duration: '30 min', price: '12 €' },
    ],
    supplements: ['Vernis simple : 5 €', 'Semi-permanent : 15 €'],
  },
  {
    slug: 'spray-tan',
    icon: Droplets,
    title: 'Spray Tan BOTAN',
    shortDesc: 'Un teint lumineux et un effet retour de vacances toute l\'année, naturellement.',
    heroSubtitle: 'BOTAN illumine votre peau et révèle un teint lumineux pour un effet retour de vacances.',
    planityUrl: PLANITY_URL,
    content: [
      { heading: 'Éclat naturel', text: 'BOTAN est le soin qui illumine votre peau et révèle un teint lumineux, reposé et éclatant. Un véritable effet retour de vacances toute l\'année, sans exposition aux UV.' },
    ],
    prestations: [
      { name: 'Spray tan visage', duration: '10 min', price: '10 €' },
    ],
  },
];

export const formules: Prestation[] = [
  { name: 'Découverte Visage', duration: '1h30', price: '110 €', description: 'Softskin "peaux sensibles" + Eyedermaskin "contour des yeux"' },
  { name: 'Peau Neuve', duration: '1h25', price: '110 €', description: 'Peeldermaskin Light + Photothérapie LED' },
  { name: 'Beauté Express', duration: '1h', price: '70 €', description: 'Skincleantech + Pressothérapie détente' },
  { name: 'Corps Sculpté', duration: '1h', price: '60 €', description: 'Lipolaser ventre + culotte de cheval + Pressothérapie' },
];

export const formulesEpilation: Prestation[] = [
  { name: 'Corps complet', duration: '1h', price: '75 €', description: 'Aisselles + maillot intégral + bras + jambes' },
  { name: 'Formule 1', duration: '20 min', price: '30 €', description: 'Aisselles + maillot classique + ½ jambes' },
  { name: 'Formule 2', duration: '30 min', price: '40 €', description: 'Aisselles + maillot classique + jambes entières' },
  { name: 'Formule 3', duration: '20 min', price: '25 €', description: 'Aisselles + maillot classique + ½ bras' },
  { name: 'Formule 4', duration: '30 min', price: '35 €', description: 'Aisselles + maillot classique + bras entiers' },
];
